/* VELVOON — cart drawer (v2): overlay under navbar, scrim, perks, savings */
(() => {
  const root = document.documentElement;
  const DESKTOP = 990;
  const ico = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    cash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><rect x="3" y="6.5" width="18" height="11" rx="1.5"/><circle cx="12" cy="12" r="2.6"/></svg>',
    ret: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h11a5 5 0 0 1 0 10H8"/><path d="M8 5 4 9l4 4"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12.5 2.6 2.5L16 9.5"/></svg>'
  };

  /* ---- position under the navbar (desktop) ---- */
  let raf = 0;
  const place = () => {
    raf = 0;
    const hdr = document.querySelector('#header-component');
    const y = innerWidth >= DESKTOP && hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 0;
    root.style.setProperty('--vv-cart-top', y + 'px');
  };
  const queue = () => { if (!raf) raf = requestAnimationFrame(place); };
  addEventListener('resize', queue, { passive: true });
  addEventListener('scroll', queue, { passive: true, capture: true }); // page-wrapper is the scroller on desktop

  /* ---- scrim ---- */
  const scrim = document.createElement('div');
  scrim.className = 'vv-cart-scrim';
  scrim.setAttribute('aria-hidden', 'true');
  scrim.addEventListener('click', () => document.querySelector('#cart-drawer .theme-drawer__close-button')?.click());

  const money = (txt) => {
    const m = String(txt || '').match(/\d[\d,]*(?:\.\d+)?/);
    const n = m ? parseFloat(m[0].replace(/,/g, '')) : NaN;
    return Number.isFinite(n) ? n : 0;
  };
  const fmt = (n) => 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  /* ---- dress the drawer contents (re-run after every cart re-render) ---- */
  const dress = () => {
    const dlg = document.querySelector('#cart-drawer .theme-drawer__dialog');
    if (!dlg) return;
    const hasItems = !!dlg.querySelector('.cart-form .cart-items__table-row[data-key]');

    // free-shipping strip under header
    const head = dlg.querySelector('.theme-drawer__header');
    let perk = dlg.querySelector('.vv-cart-perk');
    if (hasItems && head && !perk) {
      perk = document.createElement('p');
      perk.className = 'vv-cart-perk';
      perk.innerHTML = ico.check + '<span>You’ve unlocked <b>free shipping</b> across India</span>';
      head.insertAdjacentElement('afterend', perk);
    } else if (!hasItems && perk) perk.remove();

    // per-line savings + total savings
    let saved = 0;
    dlg.querySelectorAll('.cart-items__table-row[data-key]').forEach((row) => {
      const cmp = money(row.querySelector('.compare-at-price')?.textContent);
      const unitEl = row.querySelector('.cart-items__unit-price-wrapper span:not(.visually-hidden)');
      const unit = money(unitEl?.textContent);
      const qty = parseInt(row.querySelector('input[name="updates[]"]')?.value || '1', 10) || 1;
      const details = row.querySelector('.cart-items__details');
      let tag = row.querySelector('.vv-line-save');
      if (cmp > unit && unit > 0) {
        const pct = Math.round((1 - unit / cmp) * 100);
        saved += (cmp - unit) * qty;
        if (!tag && details) { tag = document.createElement('span'); tag.className = 'vv-line-save'; details.appendChild(tag); }
        if (tag && tag.textContent !== pct + '% off') tag.textContent = pct + '% off';
      } else tag?.remove();
    });
    const totals = dlg.querySelector('.cart-totals__container');
    let save = dlg.querySelector('.vv-cart-save');
    if (totals && saved > 0) {
      if (!save) { save = document.createElement('div'); save.className = 'vv-cart-save'; totals.prepend(save); }
      const h = '<span>You save</span><span>' + fmt(saved) + '</span>';
      if (save.innerHTML !== h) save.innerHTML = h;
    } else save?.remove();

    // tax note copy
    const note = dlg.querySelector('.cart-totals__tax-note small');
    if (note && !note.dataset.vv) { note.dataset.vv = '1'; note.textContent = 'Inclusive of all taxes (GST). Free shipping across India.'; }

    // trust row after checkout button
    const ctas = dlg.querySelector('.cart__ctas');
    if (ctas && !dlg.querySelector('.vv-cart-trust')) {
      const ul = document.createElement('ul');
      ul.className = 'vv-cart-trust';
      ul.setAttribute('role', 'list');
      ul.innerHTML = '<li>' + ico.truck + 'Free shipping</li><li>' + ico.cash + 'Cash on delivery</li><li>' + ico.ret + '10-day returns</li>';
      ctas.insertAdjacentElement('afterend', ul);
    }
  };

  /* ---- open/close tracking ---- */
  const sync = () => {
    const drawer = document.getElementById('cart-drawer');
    const open = !!drawer && drawer.hasAttribute('open');
    root.classList.toggle('vv-cart-open', open);
    if (open) { place(); dress(); }
  };

  let t;
  const boot = () => {
    document.body.appendChild(scrim);
    place();
    sync();
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(sync, 60); })
      .observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setTimeout(sync, 50); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
